import { FlagsProvider } from '@atlaskit/flag';

import { AppRouteComponentContent } from './app-route';
import { AppWithRoute } from './app-with-route';
import { LazyAppRouterWithUsersPermsContext } from './lazy-app-router-with-users-perms-context';

export const AppRouteComponent = () => {
	return (
		<LazyAppRouterWithUsersPermsContext>
			<AppWithRoute>
				<FlagsProvider>
					<AppRouteComponentContent />
				</FlagsProvider>
			</AppWithRoute>
		</LazyAppRouterWithUsersPermsContext>
	);
};
